import { json } from '@remix-run/node'
import { Link, useLoaderData } from '@remix-run/react'
import { FacultyPhoto } from '#app/components/FacultyPhoto.tsx'
import { getStaffList } from '#app/models/staff.server.js'

export async function loader() {
	return json({
		staffList: await getStaffList(),
	})
}

export default function FacultyRoute() {
	const { staffList } = useLoaderData<typeof loader>()
	return (
		<main>
			<div className="relative isolate overflow-hidden bg-stone-900">
				<div className="absolute inset-x-0 top-1/2 -z-10 -translate-y-1/2 transform-gpu overflow-hidden opacity-30 blur-3xl">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[max(50%,38rem)] w-[82.0625rem]"
					>
						<path
							id="bc169a03-3518-42d4-ab1e-d3eadac65edc"
							fill="url(#85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3)"
							d="M360.508 589.796 231.671 770.522 0 498.159l360.508 91.637 232.034-325.485c1.485 150.396 51.235 393.965 238.354 165.069C1064.79 143.261 1002.42-107.094 1171.72 46.97c135.44 123.252 148.51 335.641 138.11 426.428L971.677 339.803l24.062 411.461-635.231-161.468Z"
						/>
						<defs>
							<linearGradient
								id="85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3"
								x1="1313.17"
								x2="-88.881"
								y1=".201"
								y2="539.417"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#9089FC" />
								<stop offset={1} stopColor="#FF80B5" />
							</linearGradient>
						</defs>
					</svg>
				</div>
				<div className="absolute inset-x-0 top-0 -z-10 flex transform-gpu overflow-hidden pt-32 opacity-25 blur-3xl sm:pt-40 xl:justify-end">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[-22rem] w-[82.0625rem] flex-none origin-top-right rotate-[30deg] xl:ml-0 xl:mr-[calc(50%-12rem)]"
					>
						<use href="#bc169a03-3518-42d4-ab1e-d3eadac65edc" />
					</svg>
				</div>
				<div className="px-6 pt-32 sm:px-8">
					<div className="mx-auto max-w-2xl text-center sm:pt-12">
						<h2 className="text-4xl font-bold tracking-tight text-white sm:text-6xl">
							Our Faculty
						</h2>
						<p className="mt-6 text-lg leading-8 text-gray-300">
							Our goal is to provide the highest quality dance education by
							sustaining a nurturing and positive atmosphere wherein young
							students may grow and learn.
						</p>
					</div>
				</div>
				<div className="mx-auto my-20 max-w-7xl px-6 lg:px-8">
					<ul className="space-y-12 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 sm:space-y-0 lg:grid-cols-3 lg:gap-x-8">
						{staffList.map((person) => {
							const hasProfile =
								Boolean(person.imageUrl) || person.bio.length > 0
							const card = (
								<div className="space-y-4">
									<div className="aspect-w-3 aspect-h-2">
										<FacultyPhoto
											name={person.name}
											imageUrl={person.imageUrl}
											className="h-full w-full"
										/>
									</div>

									<div className="space-y-2">
										<div className="space-y-1 text-lg font-medium leading-6 text-neutral-100">
											<h3>{person.name}</h3>
											<p className="text-base text-[#f9c04d]">{person.role}</p>
										</div>
									</div>
								</div>
							)

							return (
								<li key={person.id}>
									{hasProfile ? (
										<Link to={person.id} prefetch="intent">
											{card}
										</Link>
									) : (
										card
									)}
								</li>
							)
						})}
					</ul>
				</div>
			</div>
		</main>
	)
}
